<script>
  import Footer from "@/core/components/Footer"
  import Header from "@/core/components/Header"
  import Modal from "@/core/components/NewModal"
  import Sidebar from "@/core/components/Sidebar"
  import RegistryService from "@/core/services/RegistryService"
  import CircularWarning from "@/domains/auth/components/CircularWarning"
  import RegistrationWarning from "@/domains/auth/components/RegistrationWarning"
  import {
    confirmCircularInfo,
    confirmReregistration,
  } from "@/domains/re-registration/services/reregistration"

  // Altere para true quando desejar exibir novamente o aviso da circular
  const ENABLE_CIRCULAR_WARNING = false

  export default {
    components: {
      CircularWarning,
      Header,
      Sidebar,
      Footer,
      Modal,
      RegistrationWarning,
    },
    data() {
      return {
        registryService: new RegistryService(),
        ENABLE_CIRCULAR_WARNING,
      }
    },
    mounted() {
      if (this.$store.state.auth.link) {
        const organizationId = this.$store.state.auth.link.organization_id

        confirmReregistration(organizationId).catch(() => {
          this.showRegistrationWarning()
        })

        confirmCircularInfo(organizationId)
          .then(() =>
            this.registryService.getDeterInfoOrganization(organizationId)
          )
          .then((response) => {
            this.$store.commit("setOrganization", response[0])
            if (this.ENABLE_CIRCULAR_WARNING) {
              const typeId = response[0]?.deter_registry?.type_id

              if ([1, 2, 3, 4].includes(typeId)) {
                this.showCircularWarning()
              }
            }
          })
      }
    },
    methods: {
      toggleSidebar() {
        this.$refs.sidebar.toggleOnMobile()
      },
      showRegistrationWarning() {
        this.$refs.registrationWarning.show()
      },
      hideRegistrationWarning() {
        this.$refs.registrationWarning.hide()
      },
      showCircularWarning() {
        if (this.ENABLE_CIRCULAR_WARNING) {
          this.$refs.circularWarning.show()
        }
      },
      hideCircularWarning() {
        if (this.ENABLE_CIRCULAR_WARNING) {
          this.$refs.circularWarning.hide()
        }
      },
    },
  }
</script>

<template>
  <div class="flex flex-col min-h-screen">
    <Header @toggleSidebar="toggleSidebar"/>
    <div class="flex flex-grow w-full" :key="this.$route.meta.module">
      <portal-target name="main-modal" multiple/>
      <Sidebar v-if="!this.$route.meta.hideSidebar" id="sidebar" ref="sidebar"/>

      <Modal
        ref="registrationWarning"
        to="main-modal"
        contentClass="sm:max-w-4xl"
        :closeOnClickOutside="false"
      >
        <RegistrationWarning @close="hideRegistrationWarning"/>
      </Modal>

      <Modal
        v-if="ENABLE_CIRCULAR_WARNING"
        ref="circularWarning"
        to="main-modal"
        contentClass="sm:max-w-4xl"
        :closeOnClickOutside="false"
      >
        <CircularWarning @close="hideCircularWarning"/>
      </Modal>

      <router-view class="flex-grow"/>
    </div>
    <Footer/>
  </div>
</template>
